import { IChatsAPIErrorResponse } from '@cian/chats-api/lib/browser-entry';

import { TChatList } from './chatList';
import { TExperimentsState } from './experiments';
// eslint-disable-next-line import/no-cycle
import { IMessagesQueueState } from './messagesQueue';
import { INotificationsState } from './notifications';
// eslint-disable-next-line import/no-cycle
import { TSessionState } from './session';
import { TUser } from './userData';

export type TAPIErrors = IChatsAPIErrorResponse;

export enum ERequestApiStatus {
  Initial = 'initial',
  Pending = 'pending',
  Succeed = 'succeed',
  Failed = 'failed',
}

export enum EWsClientEventType {
  Message = 'message',
  Session = 'session',
  Answer = 'answer',
  UnsubscribeUsersStatus = 'unsubscribeUsersStatus',
  SubscribeUsersStatus = 'subscribeUsersStatus',
}

export type TWidgetState = {
  notifications: INotificationsState;
  experiments: TExperimentsState;
  session: TSessionState;
  socketStatus: ERequestApiStatus;
  user: TUser;
  chatList: TChatList;
  messagesQueue: IMessagesQueueState;
};
